import { QueryHookOptions } from '@apollo/client';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useAllAgenciesForSearchQuery } from '@anytag/graphql';

export const useAllAgenciesForSearchOptions = (options?: QueryHookOptions<Query>) => {
  const { data, loading } = useAllAgenciesForSearchQuery({ fetchPolicy: 'cache-and-network', ...options });

  return {
    loading,
    allAgencyOptions: getSelectOptions(data?.allAgenciesForSearch)
  };
};
